export const VALORATION_FINALIZED_TEXTS = {
  SURVEY: {
    TITLE: 'Comparte tu experiencia',
    DESCRIPTION:
      'Queremos conocer tu opinión. Cuéntanos cómo fue tu experiencia en estos 6 meses de crecimiento y ayúdanos a mejorarla.',
    BUTTON: 'Responder encuesta',
    NOTE: 'Esta pantalla de resultados estará disponible durante una semana. Al finalizar este periodo, se reiniciará tu gestión de review para que continúes avanzando en tu desarrollo.',
  },
  RESULTS: {
    TITLE: '¡Felicitaciones, has completado tu review de crecimiento!',
    DESCRIPTION:
      'Descubre tu resultado y revisa las recomendaciones para seguir creciendo en tu camino profesional.',
    BUTTON: 'Ver resultados',
  },
};
